import { responsiveModalOpened, type BaseOpenResponsiveModalPayload } from '../../model';

export const openResponsiveModal = (payload: BaseOpenResponsiveModalPayload) => {
    responsiveModalOpened(payload);
};
